import { InvitationStatus } from "@features/invitations/types/invitation";

/**
 * Maps invitation statuses to their corresponding CSS border accent classes.
 *
 * The keys represent possible invitation statuses, and the values are the CSS class names
 * used to style the border of the invitation card according to its status.
 *
 * - `pending`: Uses the "border-warning" class for pending invitations.
 * - `accepted`: Uses the "border-success" class for accepted invitations.
 * - `cancelled`: Uses the "border-danger" class for cancelled invitations.
 * - `rejected`: Uses the "border-danger" class for rejected invitations.
 */
const statusAccentMap: Record<string, string> = {
    pending: "border-warning",
    accepted: "border-success",
    cancelled: "border-danger",
    rejected: "border-danger",
};

/**
 * Returns the accent (CSS border class) associated with a given invitation status.
 *
 * @param status - The invitation status as an `InvitationStatus` enum value or string.
 * @returns The corresponding accent class name (e.g., "border-primary").
 *          If the status is not recognized, returns "border-primary" by default.
 */
export const accentFor = (status: InvitationStatus | string) =>
    statusAccentMap[(status || "").toLowerCase()] || "border-primary";